import { RejectionReasonModel } from './RejectionReasonModel';

export const otherRejectionReasonId = '0';
export const otherRejectionReasonMaxLength = 700;
export const senderNameRequestType = 1;
export const contractRequestType = 2;
export const messageTemplateRequestType = 3;

export function otherRejectionReason(requestType: number, label: string): RejectionReasonModel {
    return {
        id: otherRejectionReasonId,
        rejectionText: label,
        requestType,
    };
}

export function isOtherRejectionReasonSelected(selected: RejectionReasonModel[]): boolean {
    if (!selected) {
        return false;
    }
    for (const reason of selected) {
        if (reason && reason.id === otherRejectionReasonId) {
            return true;
        }
    }
    return false;
}

export function rejectionSelectionIsValid(selected: RejectionReasonModel[], otherText: string): boolean {
    if (!selected || selected.length === 0) {
        return false;
    }
    if (!isOtherRejectionReasonSelected(selected)) {
        return true;
    }
    if (otherText === null || otherText === undefined) {
        return false;
    }
    const trimmed = otherText.trim();
    return trimmed !== '' && trimmed.length <= otherRejectionReasonMaxLength;
}

export function composeRejectionReason(selected: RejectionReasonModel[], otherText: string): string {
    const parts: string[] = [];
    if (!selected) {
        return '';
    }
    for (const reason of selected) {
        if (!reason) {
            continue;
        }
        if (reason.id === otherRejectionReasonId) {
            if (otherText !== null && otherText !== undefined && otherText.trim() !== '') {
                parts.push(otherText.trim());
            }
        } else if (reason.rejectionText) {
            parts.push(reason.rejectionText);
        }
    }
    return parts.join(' | ');
}

export function toggleAllRejectionReasons(
    selected: RejectionReasonModel[],
    all: RejectionReasonModel[]): RejectionReasonModel[] {
    if (!all || all.length === 0) {
        return [];
    }
    if (selected && selected.length === all.length) {
        return [];
    }
    return all.slice();
}

export function allRejectionReasonsSelected(
    selected: RejectionReasonModel[],
    all: RejectionReasonModel[]): boolean {
    return !!all && all.length > 0 && !!selected && selected.length === all.length;
}
